import Button from "@mui/material/Button";
import { useMsal } from "@azure/msal-react";
import { restartLogin } from "../../../Utils/authRecovery";

export default function LoginForm() {
  const { instance } = useMsal();

  // Deja elegir la cuenta de Microsoft con la que entrar
  const handleLogin = () => {
    restartLogin(instance).catch((e) => {
      console.error(e);
    });
  };

  return (
    <Button variant="contained" fullWidth onClick={handleLogin}>
      Entrar
    </Button>
  );
}
